import { render, staticRenderFns } from "./brgd_tanilts.vue?vue&type=template&id=45d554a9&scoped=true&"
import script from "./brgd_tanilts.vue?vue&type=script&lang=js&"
export * from "./brgd_tanilts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45d554a9",
  null
  
)

export default component.exports